export default __webpack_public_path__ + "static/media/Ballroll_00320.068cd565.png";